import CommonUtil from "../utils/CommonUtil";
import { messages } from "../localization/messages";

class PasswordValidator {
  validate(password, passwordConfirm, passwordRequirements) {
    const passwordsValidation = this.validatePasswords(
      password,
      passwordConfirm
    );

    const passwordLengthValidation = this.validatePasswordLength(
      password,
      passwordRequirements
    );
    const hasDigitValidation = this.validatePasswordHasDigit(
      password,
      passwordRequirements
    );
    const hasLowerCasedCharValidation = this.validatePasswordHasLowerCasedChar(
      password,
      passwordRequirements
    );
    const hasUpperCasedCharValidation = this.validatePasswordHasUpperCasedChar(
      password,
      passwordRequirements
    );
    const hasSpecialCharValidation = this.validatePasswordHasSpecialChar(
      password,
      passwordRequirements
    );

    const validation =
      passwordsValidation.valid &&
      passwordLengthValidation.valid &&
      hasDigitValidation.valid &&
      hasLowerCasedCharValidation.valid &&
      hasUpperCasedCharValidation.valid &&
      hasSpecialCharValidation.valid;

    const messages = CommonUtil.constructStringArrayWithoutEmpties(
      passwordsValidation.message,
      passwordLengthValidation.message,
      hasDigitValidation.message,
      hasLowerCasedCharValidation.message,
      hasUpperCasedCharValidation.message,
      hasSpecialCharValidation.message
    );

    return {
      valid: validation,
      messages: messages
    };
  }

  validatePasswords(password, passwordConfirm) {
    const validation =
      password === passwordConfirm &&
      password.length > 0 &&
      passwordConfirm.length > 0;
    return {
      valid: validation,
      message: validation ? "" : messages.passwords_not_matching
    };
  }

  validatePassword(password, condition, check, message) {
    var validation = true;
    if (condition) {
      validation = check(password);
    }
    return {
      valid: validation,
      message: validation ? "" : message
    };
  }

  validatePasswordLength(password, passwordRequirements) {
    return this.validatePassword(
      password,
      true,
      password => {
        return password.length >= passwordRequirements.length;
      },
      messages.formatString(
        messages.password_too_short,
        passwordRequirements.length
      )
    );
  }

  validatePasswordHasDigit(password, passwordRequirements) {
    return this.validatePassword(
      password,
      passwordRequirements.hasDigit,
      CommonUtil.stringHasDigit,
      messages.password_needs_digit
    );
  }

  validatePasswordHasLowerCasedChar(password, passwordRequirements) {
    return this.validatePassword(
      password,
      passwordRequirements.hasLowerCasedChar,
      CommonUtil.stringHasLowerCasedChar,
      messages.password_needs_lowercased
    );
  }

  validatePasswordHasUpperCasedChar(password, passwordRequirements) {
    return this.validatePassword(
      password,
      passwordRequirements.hasUpperCasedChar,
      CommonUtil.stringHasUpperCasedChar,
      messages.password_needs_uppercased
    );
  }

  validatePasswordHasSpecialChar(password, passwordRequirements) {
    return this.validatePassword(
      password,
      true,
      password => {
        return (
          passwordRequirements.hasSpecialChar ===
          CommonUtil.stringHasSpecialChar(password)
        );
      },
      messages.password_not_allowed_special
    );
  }
}

export default PasswordValidator;
